<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Thread analysis dashboard view with time range selector, pie chart for runtime distribution, and job runs table with master-detail filtering
-->
@if (initialized) {
    <div class="grid mt-2">

        <!-- Toolbar: Time Range Selector -->
        <div class="col-12">
            <div class="flex justify-content-between py-2 px-4 surface-0 align-items-center shadow-1 border-round">
                <span class="font-semibold text-lg">Thread-Analyse</span>
                <mvs-range-selector-overlay
                    fieldName="e.startTime"
                    placeholder="Zeitraum wählen"
                    (onChangeFilterCriteria)="handleFilterCriteria($event)"
                    (onClear)="handleClearFilter()">
                </mvs-range-selector-overlay>
            </div>
        </div>

        <!-- Chart + Table Side by Side -->
        <div class="col-5">
            <div class="card shadow-1 border-round surface-0">
                @if (chartWidget) {
                    <mvs-widget
                        [widgetData]="chartWidget"
                        (onFilterChange)="handleChartFilterChange($event)">
                    </mvs-widget>
                }
            </div>
        </div>

        <div class="col-7">
            <div class="card shadow-1 border-round surface-0">
                @if (tableWidget) {
                    <mvs-widget
                        [widgetData]="tableWidget">
                    </mvs-widget>
                }
            </div>
        </div>

    </div>
}
